"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeListTenantsState = exports.changeUpdateTenantState = exports.changeCreateTenantState = exports.clearAllTenantForms = exports.clearUpdateTenantParams = exports.clearCreateTenantParams = exports.changeUpdateTenantParams = exports.changeCreateTenantParams = exports.changeTenantListConfig = exports.CHANGE_TENANT_LIST_CONFIG = exports.loadTenantToUpdate = exports.LOAD_TENANT_TO_UPDATE = exports.changeTenantState = exports.CHANGE_TENANT_STATE = exports.clearTenantParams = exports.CLEAR_TENANT_PARAMS = exports.changeTenantParams = exports.CHANGE_TENANT_PARAMS = exports.setAllTenants = exports.SET_ALL_TENANTS = exports.setTenants = exports.SET_TENANTS = void 0;

var _reduxBatchedActions = require("redux-batched-actions");

var _getActionName = require("skybase-ui/skybase-core/utils/get-action-name");

var _createAction = require("skybase-ui/skybase-core/base/create-action");

var _constants = require("./constants");

var _constants2 = require("../constants");

var CREATE_TENANT = _constants.TENANTS_STATE_KEYS.CREATE_TENANT,
    UPDATE_TENANT = _constants.TENANTS_STATE_KEYS.UPDATE_TENANT,
    LIST = _constants.TENANTS_STATE_KEYS.LIST;
var SET_TENANTS = (0, _getActionName.getActionName)('SET_TENANTS', _constants2.MODULE_NAME);
exports.SET_TENANTS = SET_TENANTS;

var setTenants = function setTenants(tenants) {
  return (0, _createAction.createAction)(SET_TENANTS, {
    tenants: tenants
  });
};

exports.setTenants = setTenants;
var SET_ALL_TENANTS = (0, _getActionName.getActionName)('SET_ALL_TENANTS', _constants2.MODULE_NAME);
exports.SET_ALL_TENANTS = SET_ALL_TENANTS;

var setAllTenants = function setAllTenants(tenants) {
  return (0, _createAction.createAction)(SET_ALL_TENANTS, {
    tenants: tenants
  });
};

exports.setAllTenants = setAllTenants;
var CHANGE_TENANT_PARAMS = (0, _getActionName.getActionName)('CHANGE_TENANT_PARAMS', _constants2.MODULE_NAME);
exports.CHANGE_TENANT_PARAMS = CHANGE_TENANT_PARAMS;

var changeTenantParams = function changeTenantParams(key, attribute, value) {
  return (0, _createAction.createAction)(CHANGE_TENANT_PARAMS, {
    key: key,
    attribute: attribute,
    value: value
  });
};

exports.changeTenantParams = changeTenantParams;
var CLEAR_TENANT_PARAMS = (0, _getActionName.getActionName)('CLEAR_TENANT_PARAMS', _constants2.MODULE_NAME);
exports.CLEAR_TENANT_PARAMS = CLEAR_TENANT_PARAMS;

var clearTenantParams = function clearTenantParams(key) {
  return (0, _createAction.createAction)(CLEAR_TENANT_PARAMS, {
    key: key
  });
};

exports.clearTenantParams = clearTenantParams;
var CHANGE_TENANT_STATE = (0, _getActionName.getActionName)('CHANGE_TENANT_STATE', _constants2.MODULE_NAME);
exports.CHANGE_TENANT_STATE = CHANGE_TENANT_STATE;

var changeTenantState = function changeTenantState(key, state) {
  return (0, _createAction.createAction)(CHANGE_TENANT_STATE, {
    key: key,
    state: state
  });
};

exports.changeTenantState = changeTenantState;
var LOAD_TENANT_TO_UPDATE = (0, _getActionName.getActionName)('LOAD_TENANT_TO_UPDATE', _constants2.MODULE_NAME);
exports.LOAD_TENANT_TO_UPDATE = LOAD_TENANT_TO_UPDATE;

var loadTenantToUpdate = function loadTenantToUpdate(tenant) {
  return (0, _createAction.createAction)(LOAD_TENANT_TO_UPDATE, {
    tenant: tenant
  });
};

exports.loadTenantToUpdate = loadTenantToUpdate;
var CHANGE_TENANT_LIST_CONFIG = (0, _getActionName.getActionName)('CHANGE_TENANT_LIST_CONFIG', _constants2.MODULE_NAME);
exports.CHANGE_TENANT_LIST_CONFIG = CHANGE_TENANT_LIST_CONFIG;

var changeTenantListConfig = function changeTenantListConfig(config) {
  return (0, _createAction.createAction)(CHANGE_TENANT_LIST_CONFIG, {
    config: config
  });
}; // Factory actions


exports.changeTenantListConfig = changeTenantListConfig;

var changeCreateTenantParams = function changeCreateTenantParams(attribute, value) {
  return changeTenantParams(CREATE_TENANT, attribute, value);
};

exports.changeCreateTenantParams = changeCreateTenantParams;

var changeUpdateTenantParams = function changeUpdateTenantParams(attribute, value) {
  return changeTenantParams(UPDATE_TENANT, attribute, value);
};

exports.changeUpdateTenantParams = changeUpdateTenantParams;

var clearCreateTenantParams = function clearCreateTenantParams() {
  return clearTenantParams(CREATE_TENANT);
};

exports.clearCreateTenantParams = clearCreateTenantParams;

var clearUpdateTenantParams = function clearUpdateTenantParams() {
  return clearTenantParams(UPDATE_TENANT);
};

exports.clearUpdateTenantParams = clearUpdateTenantParams;

var clearAllTenantForms = function clearAllTenantForms() {
  return function (dispatch) {
    dispatch((0, _reduxBatchedActions.batchActions)([clearCreateTenantParams(), clearUpdateTenantParams()]));
  };
};

exports.clearAllTenantForms = clearAllTenantForms;

var changeCreateTenantState = function changeCreateTenantState(state) {
  return changeTenantState(CREATE_TENANT, state);
};

exports.changeCreateTenantState = changeCreateTenantState;

var changeUpdateTenantState = function changeUpdateTenantState(state) {
  return changeTenantState(UPDATE_TENANT, state);
};

exports.changeUpdateTenantState = changeUpdateTenantState;

var changeListTenantsState = function changeListTenantsState(state) {
  return changeTenantState(LIST, state);
};

exports.changeListTenantsState = changeListTenantsState;
//# sourceMappingURL=actions.js.map